import {
    createApiRef,
    DiscoveryApi,
    FetchApi,
} from "@backstage/core-plugin-api";

const pluginId = "oneshotsql";

export const OneShotSqlRef = createApiRef<OneShotSqlApi>({
    id: pluginId,
});

export interface OneShotSqlApi {
    run(orgName: string, env: string, prLink: string): Promise<Response>;
    getOrganizations(): Promise<Response>;
    getEnvironmentsForOrg(orgName: string): Promise<Response>;
    getHistoryForOrg(orgName: string): Promise<Response>;
}

export class OneShotSqlClient implements OneShotSqlApi {
    private readonly discoveryApi: DiscoveryApi;
    private readonly fetchApi: FetchApi;

    constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
        this.discoveryApi = options.discoveryApi;
        this.fetchApi = options.fetchApi;
    }

    async run(orgName: string, env: string, prLink: string): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/${orgName}/run`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                env: env,
                org: orgName,
                prLink: prLink,
            }),
        });
    }

    async getOrganizations(): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/organizations`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    async getEnvironmentsForOrg(orgName: string): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/${orgName}/environments`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    async getHistoryForOrg(orgName: string): Promise<Response> {
        const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);
        return await this.fetchApi.fetch(`${baseUrl}/${orgName}/history`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
}
